'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'rainbow';
var width = 640;
var height = 512;
var aliases = [127752];
var unicode = 'f75b';
var svgPathData = ['M24 448c13.3 0 24-10.7 24-24l0-72C48 201.8 169.8 80 320 80S592 201.8 592 352l0 72c0 13.3 10.7 24 24 24l-112 0c13.3 0 24-10.7 24-24l0-72c0-114.9-93.1-208-208-208S112 237.1 112 352l0 72c0 13.3 10.7 24 24 24L24 448zm112 0c13.3 0 24-10.7 24-24l0-72c0-88.4 71.6-160 160-160s160 71.6 160 160l0 72c0 13.3 10.7 24 24 24l-112 0c13.3 0 24-10.7 24-24l0-72c0-53-43-96-96-96s-96 43-96 96l0 72c0 13.3 10.7 24 24 24l-112 0z', 'M320 80C169.8 80 48 201.8 48 352l0 72c0 13.3-10.7 24-24 24S0 437.3 0 424l0-72C0 175.3 143.3 32 320 32S640 175.3 640 352l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72C592 201.8 470.2 80 320 80zm0 112c-88.4 0-160 71.6-160 160l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-114.9 93.1-208 208-208s208 93.1 208 208l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-88.4-71.6-160-160-160zM272 352l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-53 43-96 96-96s96 43 96 96l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-26.5-21.5-48-48-48s-48 21.5-48 48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;